<template>
  <ModeSelector />
  <router-view />
</template>

<script setup lang="ts">
import ModeSelector from '@/components/ModeSelector.vue';
</script>
